export const API_URL = "https://staging.api.topcoinuk.com"; 
// export const API_URL = "http://127.0.0.1:8000"; 